<template>
  <div class="">


    <div class="container">

      <div class="row">
        <div class="col-lg-6">
          <h5>ارسال پیام</h5>
        </div>
        <div class="col-lg-6 text-left">

          <m-a :href="{name:'SendSms'}">
            <button type="button" class="btn rounded-pill btn-primary ml-1 ">بخش ارسال پیام</button>
          </m-a>
        </div>
      </div>


      <div class="col-lg-9 mx-auto">


        <form @submit.prevent="submit">


          <div class="row">
            <div class="col-lg-6">
              <div class="col-lg-12 text-right my-2">
                <form-group :validations="$v.form.name">
                  <div slot-scope="{ errors, invalid }">

                    <div class="form-group">
                      <label for="exampleFormControlTextarea12">نام گروه</label>
                      <input type="text" v-model="form.name" class="form-control "
                             id="exampleFormControlTextarea12"/>
                    </div>

                    <form-errors-manager :errors="errors"/>
                  </div>
                </form-group>


              </div>

              <div class="col-lg-12 text-right my-2">
                <form-group :validations="$v.form.template">
                  <div slot-scope="{ errors, invalid }">

                    <div class="form-group">
                      <label for="exampleFormControlTextarea12">قالب</label>
                      <select @change="showTemplateText" class="custom-select" v-model="form.template">
                        <option selected value="">انتخاب قالب</option>
                        <option v-for="template in smsTemplates" :value="template">{{ template.name }}</option>
                      </select>
                    </div>

                    <form-errors-manager :errors="errors"/>
                  </div>
                </form-group>


              </div>

            </div>


            <div class="col-lg-6">
              <form-group :validations="$v.form.cellphones">
                <div slot-scope="{ errors, invalid }">

                  <div class="form-group">
                    <label for="sms-template-numbers">شماره ها</label>
                    <textarea class="form-control" v-model="form.cellphones" rows="9"
                              id="sms-template-numbers"></textarea>


                    <span class="mx-1 badge badge-danger">تعداد: <span>{{ cellphoneCounts }}</span></span>
                  </div>


                  <form-errors-manager :errors="errors"/>
                </div>
              </form-group>
            </div>


            <div class="col-12">

              <div class="row">
                <div class="col-lg-3" v-for="variable in form.items">
                  <sms-variable :item="variable"/>
                </div>
              </div>

            </div>
            <div class="col-12">

              <div class="form-group">
                <label for="sms_preview">پیش نمایش</label>
                <textarea v-model="smsPreview" class="form-control" readonly id="sms_preview" rows="8"></textarea>
              </div>
              <span class="mx-1 badge badge-danger">پیام: <span>{{ smsCharacter }}</span></span>
              <span class="mx-1 badge badge-danger">تعداد کل: <span>{{ smsCount }}</span></span>


            </div>


            <div class="col-12 text-center">
              <button ref="submit-button" class="btn btn-primary px-5 rounded-pill">ارسال پیام</button>
            </div>
          </div>

        </form>


      </div>
    </div>


  </div>
</template>

<script>
import FormErrorsManager from "@/plugin/components/validator/FormErrorsManager.vue";
import FormGroup from "@/plugin/components/validator/FormGroup.vue";
import {minLength, required} from "vuelidate/lib/validators";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import SmsVariable from "./SendSmsWithTemplateComponents/SmsVariable.vue";
import {calculateSms, checkNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Sms";

export default {
  name: "SendSmsWithTemplate",
  components: {SmsVariable, FormGroup, FormErrorsManager},
  data() {
    return {
      smsTemplates: [],
      smsPreview: '',
      smsCharacter: 0,
      smsCount: 0,
      cellphoneCounts: 0,
      form: {
        name: "",
        cellphones: '',
        template: '',
        items: []
      }
    }
  },
  validations: {
    form: {
      name: {required},
      cellphones: {required},
      template: {required},
    }
  },
  methods: {
    calculateSms,
    checkNumber,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    submit() {
      if (this.invalid()) {

        let form = {
          type: 0,
          name: this.form.name,
          raw_text: "",
          sms_template_id: this.form.template.id,
          items: []
        }

        let cellphone = this.form.cellphones
        cellphone = cellphone.split('\n').filter(item => item.length > 0)

        cellphone.forEach(item => {
          if (!this.checkNumber(item)) {
            toast('خطا در شماره', `شماره ${item} معتبر نیست.`, 'danger')
            throw 'number error';
          }


          let formItem = this.form.items.reduce((acc, item) => {
            acc[item.name] = item.value;

            if (item.value.length > 50) {
              toast('خطا در متغیر', `مقدار ${item.name} بیشتر از 50 کاراکتر است.`, 'danger')
              throw 'variable character error';
            }

            return acc;
          }, {});

          formItem['number'] = item

          form.items.push(formItem)

        })

        this.$refs["submit-button"].disabled = true

        let req = this.$store.dispatch('Sms/sendSms', form)
        req.then(res => {
          this.$refs["submit-button"].disabled = false
          toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
        })
            .catch(err => {
              this.$refs["submit-button"].disabled = false
              console.log(err)
            })

      }
    },
    async getSmsTemplates() {
      let templates = await this.$store.dispatch('Sms/getSmsTemplates')
      this.smsTemplates = templates.data.data.data
    },
    extractTemplateVariables(text) {
      const regex = /\[([^\]]+)\]/g;

      const matches = [];
      let match;
      while ((match = regex.exec(text)) !== null) {
        matches.push(match[1]); // match[1] contains the value inside the brackets
      }
      return matches
    },
    setFormItems() {
      let items = this.extractTemplateVariables(this.smsPreview)
      this.form.items = []
      items.forEach((item) => {
        this.form.items.push({
          name: item,
          value: ""
        })
      })
    },
    showTemplateText() {
      this.smsPreview = this.form.template.template
      this.setFormItems()
    },
    replaceVariablesInsidePreview() {

      let baseTemplate = this.form.template.template
      this.form.items.forEach(variable => {
        let name = variable['name']
        let value = variable['value']
        baseTemplate = baseTemplate.replaceAll(`[${name}]`, value)
      })

      this.smsPreview = baseTemplate


    },
  },
  async mounted() {
    await this.getSmsTemplates()
  },
  watch: {
    "form.items": {
      async handler(newValue, oldValue) {
        if (newValue != null) {
          this.replaceVariablesInsidePreview()
        }
      },
      deep: true
    },
    "smsPreview": {
      async handler(newValue, oldValue) {
        if (newValue != null) {
          this.replaceVariablesInsidePreview()
        }
      },
      deep: true
    },
    "form": {
      async handler(newValue, oldValue) {
        if (newValue != null) {
          this.smsCharacter = this.calculateSms(this.smsPreview)


          // calculate cellphone count
          const regex = /\b09\d{9}\b/g;
          const matches = this.form.cellphones.match(regex);
          this.cellphoneCounts = matches ? matches.length : 0;

          // calculate sms count
          this.smsCount = this.smsCharacter * this.cellphoneCounts

        }
      },
      deep: true
    },

  }
}
</script>

<style scoped>
</style>